// extracted by mini-css-extract-plugin
export default {"setting--inverted":"XgRUf9e","dark-theme":"Q_lHQ_v","facts__highlight":"CESODc6","facts__subline":"UQamy5F"};